<template>
  <v-container>
    <v-form ref="form" v-model="valid" @submit.prevent="submitCadastro" >
      <v-list class="pa-0" two-line>
        <v-toolbar height="56" color="primary">
          <v-toolbar-title class="subheading white--text">
            Editar cadastro do veículo
          </v-toolbar-title>
        </v-toolbar>
          <v-card class="pa-4">
            <v-layout row wrap>
              <v-flex class="flex-cadastro" xs12 sm3 md3>
                <v-text-field
                  label="Placa"
                  v-model="veiculo.placa"
                  required
                  :rules="regras.notNull"
                >
                </v-text-field>
              </v-flex>
              <v-flex class="flex-cadastro" xs12 sm3 md3>
                <v-text-field
                  label="Chassi"
                  v-model="veiculo.chassi"
                  required
                  :rules="regras.notNull"
                >
                </v-text-field>
            </v-flex>
            <v-flex class="flex-cadastro" xs12 sm3 md3>
              <v-text-field
                label="Fipe"
                v-model="veiculo.fipe"

              >
              </v-text-field>
            </v-flex>

           <v-flex class="flex-cadastro" xs12 sm3 md3>
              <v-text-field
                label="Ano do Modelo"
                type="number"
                required
                v-model="veiculo.anoModelo"
                :rules="regras.notNull"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex class="flex-cadastro" xs12 sm3 md3>
              <v-text-field
                label="Marca"
                v-model="veiculo.marca"
                required
                :rules="regras.notNull"
              >
              </v-text-field>
            </v-flex>
            <v-flex class="flex-cadastro" xs12 sm3 md3>
              <v-text-field
                label="Modelo"
                v-model="veiculo.modelo"
                required
                :rules="regras.notNull"
              >
              </v-text-field>
            </v-flex>
            <v-flex class="flex-cadastro" xs12 sm3 md3>
              <v-select
                label="Tipo"
                :items="campos.tipoVeiculoList"
                v-model="veiculo.idTipoVeiculo"
                item-text="titulo"
                item-value="id"
                required
                :rules="regras.notNull"
              >
              </v-select>
            </v-flex>
            <v-flex class="flex-cadastro" xs12 sm3 md3>
              <v-text-field
                label="Valor Fipe"
                v-model="veiculo.valor"

              >
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex class="flex-cadastro" xs12 sm3 md3>
              <v-text-field
                label="Quantidade de Passageiros"
                v-model="veiculo.qtdPassageiro"

              >
              </v-text-field>
            </v-flex>
          </v-layout>
        </v-card>
      </v-list>
      <v-flex class="flex-row mt-4">
        <v-btn  @click="voltar">
          Voltar
        </v-btn>
        <v-btn color="primary" type="submit">
            Salvar
          </v-btn>
      </v-flex>
    </v-form>
    <v-snackbar v-model="snack" :timeout="3500" :color="snackColor">
      {{ snackText }}
      <v-btn flat @click="snack = false">Fechar</v-btn>
    </v-snackbar>
    <v-snackbar v-model="msgErro" :timeout="3500" :color="red">
      {{ snackText }}
      <v-btn flat @click="msgErro = false" >Fechar</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";
export default {
  name: "InfoVeiculos",
  data() {
    return {
      valid: true,
      chassi: null,
      veiculo: { valor: 0, modelo: null, placa: null },
      placaNaoModificado: null,
      chassiNaoModificado: null,
      placaModificado: null,
      chassiMofificado: null,
      campos: {
        tipoVeiculoList: [],
      },
      regras: {
        notNull: [v => !!v || "Você não pode deixar este campo em branco"],
      },
      snack: false,
      red: "#F44336",
      snackColor: "",
      snackText: "",
      msgErro: false
    }

  },
  mounted() {
    this.$store.commit("startLoading");
    this.buscarVeiculo(this.$route.query.placa, this.$route.query.chassi, this.$route.query.codigoFipe);
    this.buscaOpcoes();

  },
  computed: {

  },
  methods: {
    voltar() {
      this.$router.push('/GridCadastroVeiculos');
    },
    submitCadastro()  {
      if (this.$refs.form.validate()) {
        axios
          .post(
          `${process.env.URL_VEICULOMS}/v1/${this.chassi}`, this.veiculo,

            {
              headers: {
                Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
              }
            }
          ).then(() => {
              this.save();
              setTimeout(() => {
                this.$router.push("/GridCadastroVeiculos");
              }, 2000);
            })
          .catch(err => {
            this.erro(err.response.data.message)
            this.$store.commit("endLoading");
          });
      }

    },
    formatMoney(amount) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(amount || 0);
    },
    buscaOpcoes() {
      axios
        .get(`${process.env.URL_PLANILHAMS}/v1/buscarOpcoesCampos/`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
          },
        })
        .then((response) => {
          [
            "tipoVeiculoList",
          ].forEach((nome) => {
            this.campos[nome] =
              response.data[nome] instanceof Array ? response.data[nome] : [];
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    buscarVeiculo(placa, chassi, fipe) {
      this.chassi = chassi
       axios
        .get(
        `${process.env.URL_VEICULOMS}/v1/buscarVeiculo/${chassi}/${placa}/${fipe}`,

          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.veiculo = response.data[0];
          this.veiculo.autenticao = response.data[0].autenticao
          this.veiculo.id = response.data[0].id

          this.$store.commit("endLoading");
        })
        .catch(err => {
          this.$store.commit("endLoading");
        });


    },
    save() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Item salvo";
    },
    erro(erro) {
      this.msgErro = true;
      this.snackColor = "error";
      this.snackText = erro;
    }
  }
}
</script>

<style>
  .flex-cadastro {
    padding: 20px;
  }
  .flex-row {
    justify-content: space-between;
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/cadastro-veiculos/InfoVeiculos.vue